/* ==========================================================================
   umbral — theme behaviour
   1. Live clock (visitor's local time, updates every minute)
   2. Mosaic (one crossfade per tick, the only animation on the page)
   3. Cart (the button that rides along, the panel, adding and changing)
   4. Tiers (one pack, two, three: what the add button sends)
   5. Buy now (adds and goes straight to checkout)
   6. Language suggestion bar

   Copy lives in locales/*.json and is rendered by Liquid. Nothing user-facing
   is hardcoded here. Every form is a native Shopify form and works without
   JavaScript; the scripts below only add the multi-item cases.
   ========================================================================== */

(function () {
  'use strict';

  var DISMISS_KEY = 'umbral-lang-dismissed';

  function $(id) {
    return document.getElementById(id);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function pageLang() {
    return (document.documentElement.lang || 'en').toLowerCase();
  }

  function primary(tag) {
    return String(tag || '').toLowerCase().split('-')[0];
  }

  function readJSON(id) {
    var el = $(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Submit through the listeners, so the tier logic runs. */
  function submitForm(form) {
    if (form.requestSubmit) {
      form.requestSubmit();
      return;
    }
    var ev = document.createEvent('Event');
    ev.initEvent('submit', true, true);
    if (form.dispatchEvent(ev)) form.submit();
  }

  /* ------------------------------------------------------------------------
     1. Clock
     Time follows the visitor's device locale (12 h or 24 h). Date wording
     follows the page language, which Shopify sets on <html lang>.
     ------------------------------------------------------------------------ */

  function initClock() {
    var clockTime = $('clock-time');
    var clockPeriod = $('clock-period');
    var clockDate = $('clock-date');
    if (!clockTime) return;

    var deviceLocale = navigator.language || 'en';

    function render() {
      var now = new Date();
      var hour = '';
      var minute = '';
      var period = '';

      try {
        new Intl.DateTimeFormat(deviceLocale, { hour: 'numeric', minute: '2-digit' })
          .formatToParts(now)
          .forEach(function (part) {
            if (part.type === 'hour') hour = part.value;
            if (part.type === 'minute') minute = part.value;
            if (part.type === 'dayPeriod') period = part.value;
          });
      } catch (e) {
        hour = String(now.getHours());
        minute = pad(now.getMinutes());
      }

      clockTime.textContent = hour + ':' + minute;
      clockTime.setAttribute('datetime', pad(now.getHours()) + ':' + pad(now.getMinutes()));
      if (clockPeriod) {
        clockPeriod.textContent = period ? ' ' + period.replace(/\./g, '').toUpperCase() : '';
      }

      if (clockDate) {
        try {
          clockDate.textContent = new Intl.DateTimeFormat(pageLang(), {
            weekday: 'long', month: 'long', day: 'numeric'
          }).format(now);
        } catch (e) {
          clockDate.textContent = now.toDateString();
        }
      }
    }

    render();

    /* Align the first tick to the next full minute, then tick every 60 s. */
    setTimeout(function () {
      render();
      setInterval(render, 60000);
    }, 60000 - (Date.now() % 60000));

    /* Catch up after the tab was in the background. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) render();
    });
  }

  /* ------------------------------------------------------------------------
     2. Mosaic
     Tiles marked data-rotate take turns: every tick one of them crossfades
     to the next file in the archive, so over time the mosaic shows the whole
     thing. Files and interval come from the section's JSON payload, so the
     theme editor drives it. Tiles CSS has hidden are skipped, so a phone
     never downloads what it cannot show.
     ------------------------------------------------------------------------ */

  function initMosaic() {
    var data = readJSON('umbral-mosaic-data');
    var cells = document.querySelectorAll('.mosaic__cell[data-rotate]');
    if (!data || !cells.length) return;

    var files = (data.files || []).filter(function (f) { return f && f.src; });
    var interval = data.interval || 6000;
    var count = cells.length;
    var start = data.start || count;

    /* Three reasons to hold still: nothing beyond what is already on screen,
       the merchant turned the crossfade off, or the visitor asked their OS
       for reduced motion. */
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (files.length <= start) return;
    if (data.rotate === false) return;
    if (reduced && reduced.matches) return;

    var slots = Array.prototype.map.call(cells, function (cell) {
      return { cell: cell, imgs: cell.querySelectorAll('.mosaic__img'), active: 0 };
    });
    var pointer = start; /* next file to bring in */
    var turn = 0;        /* which tile swaps next */

    function tick() {
      var tries = 0;
      while (tries < count && !slots[turn].cell.offsetWidth) {
        turn = (turn + 1) % count;
        tries += 1;
      }
      if (tries === count) return;

      var slot = slots[turn];
      var file = files[pointer % files.length];
      var incoming = slot.imgs[1 - slot.active];
      var outgoing = slot.imgs[slot.active];
      if (!incoming || !outgoing) return;
      var swapped = false;

      function swap() {
        if (swapped) return;
        swapped = true;
        incoming.alt = file.alt || '';
        incoming.classList.add('is-active');
        outgoing.classList.remove('is-active');
        outgoing.alt = '';
        slot.active = 1 - slot.active;
      }

      /* Wait for the file, so the crossfade never shows a half-loaded image. */
      incoming.onload = swap;
      incoming.onerror = function () { incoming.onload = null; };
      incoming.src = file.src;
      if (incoming.complete && incoming.naturalWidth > 0) swap();

      pointer += 1;
      turn = (turn + 1) % count;
    }

    setInterval(tick, interval);
  }

  /* ------------------------------------------------------------------------
     3. Cart
     One panel for the whole site, rendered by sections/cart-drawer.liquid and
     mounted in the layout. Every form that posts to /cart/add is caught here:
     the items go up through the cart API and Shopify sends back this section
     re-rendered, which is then swapped in. Money, discounts and currency are
     therefore always Shopify's own — nothing is added up in JavaScript.

     With no JavaScript, or if the request fails, the forms are ordinary
     Shopify forms and behave exactly as they always did.
     ------------------------------------------------------------------------ */

  var cartOpener = null; /* what gets the focus back when the panel closes */

  function cartData() {
    return readJSON('umbral-cart-data');
  }

  function cartPanel() {
    return document.querySelector('[data-cart-panel]');
  }

  function cartSay(text) {
    document.querySelectorAll('[data-cart-status]').forEach(function (status) { status.textContent = text || ''; });
  }

  function cartLabels() {
    var data = cartData();
    return (data && data.labels) || {};
  }

  function cartOpen(trigger) {
    var panel = cartPanel();
    var root = document.documentElement;
    if (!panel) return;

    if (!root.classList.contains('cart-open')) {
      /* Locking the page removes the scrollbar; put its width back as padding
         so nothing under the panel shifts sideways. */
      var bar = window.innerWidth - root.clientWidth;
      root.style.setProperty('--scrollbar', bar > 0 ? bar + 'px' : '0px');
      cartOpener = trigger || document.activeElement;
      root.classList.add('cart-open');
    }
    panel.focus();
  }

  function cartClose() {
    var root = document.documentElement;
    if (!root.classList.contains('cart-open')) return;
    root.classList.remove('cart-open');
    cartSay('');
    if (cartOpener && document.body.contains(cartOpener)) cartOpener.focus();
    cartOpener = null;
  }

  /* Swap in the section Shopify just re-rendered. The panel's open state
     lives on <html>, so it survives the swap; the listeners are delegated,
     so nothing needs rebinding. */
  function cartSwap(sections) {
    var data = cartData();
    var html = data && sections ? sections[data.section] : null;
    var root = data ? $('shopify-section-' + data.section) : null;
    if (!root || !html) return false;

    var holder = document.createElement('div');
    holder.innerHTML = html;
    var fresh = holder.querySelector('#' + root.id) || holder.firstElementChild;
    if (!fresh) return false;

    root.innerHTML = fresh.innerHTML;
    if (document.documentElement.classList.contains('cart-open')) {
      var panel = cartPanel();
      if (panel) panel.focus();
    }
    return true;
  }

  /* If a response ever comes back without the section in it, ask the page for
     it on its own. Shopify renders the same markup either way. */
  function cartRefresh() {
    var data = cartData();
    if (!data) return Promise.resolve();

    var search = window.location.search;
    var url = window.location.pathname + (search ? search + '&' : '?') +
      'sections=' + encodeURIComponent(data.section);

    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (json) { cartSwap(json); })
      .catch(function () { /* leave the panel as it is */ });
  }

  function cartRequest(url, body) {
    var data = cartData();
    if (!data || !url) return Promise.reject(new Error('no cart'));

    body.sections = data.section;
    body.sections_url = window.location.pathname + window.location.search;

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.text().then(function (text) {
          var json = null;
          try { json = JSON.parse(text); } catch (e) { /* an error page, not JSON */ }
          if (!response.ok) throw new Error((json && json.description) || String(response.status));
          return json || {};
        });
      })
      .then(function (json) {
        if (cartSwap(json.sections)) return json;
        return cartRefresh().then(function () { return json; });
      });
  }

  /* Serialize read/modify/write operations, including clicks from another tab
     where Web Locks is available. Each digital product has one paid copy. */
  var cartQueue = Promise.resolve();
  function cartSerial(work) {
    var next = cartQueue.then(function () {
      if (navigator.locks) return navigator.locks.request('umbral-digital-cart', work);
      return work();
    });
    cartQueue = next.catch(function () {});
    return next;
  }

  function cartRead() {
    return fetch(cartData().cart_url + '.js', {
      credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart read failed');
      return response.json();
    });
  }

  function digitalUpdates(cart) {
    var seen = Object.create(null);
    var groups = roomGroups(cart);
    var keep = groups.find(roomComplete);
    var updates = {};
    cart.items.forEach(function (item) {
      /* Keep one complete seven-design pack. A partial pack must not be sold. */
      if (isRoomLine(item)) {
        var roomQuantity = keep && keep.indexOf(item) !== -1 ? 1 : 0;
        if (item.quantity !== roomQuantity) updates[item.key] = roomQuantity;
        return;
      }
      if (item.requires_shipping) return;
      if (String(item.product_id) === String(cartData().random_product_id)) return;
      var product = String(item.product_id);
      var quantity = seen[product] ? 0 : 1;
      seen[product] = true;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    return updates;
  }

  function isRoomLine(item) {
    return (item.properties && item.properties._umbral_source === '1108') || item.product_type === 'ROOM 1108' || /^room-1108(?:-|$)/.test(item.handle || '');
  }
  function roomGroups(cart) {
    var groups = new Map();
    cart.items.filter(isRoomLine).forEach(function (item) {
      var id = (item.properties || {})._umbral_drop_id || 'legacy';
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push(item);
    });
    return Array.from(groups.values());
  }
  function roomComplete(items) {
    return items.length === 7 && new Set(items.map(function (p) { return p.variant_id; })).size === 7 &&
      new Set(items.map(function (p) { return p.product_id; })).size === 1 &&
      items.every(function (p) { return p.properties && p.properties._umbral_source === '1108' && p.properties._umbral_drop_id; }) &&
      items.map(function (p) { return String(p.properties._umbral_slot); }).sort().join(',') === '1,2,3,4,5,6,7';
  }
  function roomPriceConfirmed(cart) {
    var groups = roomGroups(cart);
    if (!groups.length) return true;
    if (groups.length !== 1 || !roomComplete(groups[0])) return false;
    var unit = groups[0][0].original_price;
    var total = groups[0].reduce(function (sum, p) { return sum + p.final_line_price; }, 0);
    return Number.isSafeInteger(unit) && unit > 0 && Number.isSafeInteger(total) && total > 0 && total <= unit &&
      groups[0].every(function (p) { return p.quantity === 1 && p.original_price === unit; });
  }
  function roomRemove(dropId) {
    return cartRead().then(function (cart) {
      var updates = {};
      cart.items.filter(isRoomLine).forEach(function (item) {
        if ((item.properties || {})._umbral_drop_id === dropId) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return cartRefresh();
      return cartRequest(cartData().cart_url + '/update.js', { updates: updates });
    });
  }

  function cartNormalize() {
    return cartRead().then(function (cart) {
      var updates = digitalUpdates(cart);
      if (!Object.keys(updates).length) return { cart: cart, changed: false, roomChanged: false };
      var roomChanged = cart.items.some(function (item) { return isRoomLine(item) && updates[item.key] !== undefined; });
      return cartRequest(cartData().cart_url + '/update.js', { updates: updates })
        .then(function (fresh) { return { cart: fresh, changed: true, roomChanged: roomChanged }; });
    });
  }

  function cartAddOnce(items) {
    return cartSerial(function () {
      return cartNormalize().then(function (state) {
        var seen = Object.create(null);
        state.cart.items.forEach(function (item) { seen[String(item.variant_id)] = true; });
        var missing = items.filter(function (item) {
          var id = String(item.id);
          if (id === String(cartData().random_variant_id)) return true;
          if (seen[id]) return false;
          seen[id] = true;
          return true;
        }).map(function (item) {
          var quantity = String(item.id) === String(cartData().random_variant_id) ? Number(item.quantity) : 1;
          if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('invalid quantity');
          return { id: item.id, quantity: quantity };
        });
        if (!missing.length) return cartRefresh();
        return cartRequest(cartData().add_url, { items: missing }).then(cartNormalize);
      });
    });
  }

  /* What a form sends. The tiers replace this with their own list. */
  /* Share the existing queue and Shopify section rendering with ROOM 1108. */
  window.UmbralCart = { serial: cartSerial, read: cartRead, request: cartRequest };

  function cartItems(form) {
    if (typeof form.umbralItems === 'function') return form.umbralItems();

    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return null;
    var amount = form.querySelector('[name="quantity"]');
    return [{ id: id.value, quantity: form.hasAttribute('data-random-add') && amount ? Number(amount.value) : 1 }];
  }

  function initCart() {
    var initial = cartData();
    if (initial && !initial.preview && window.fetch && !document.querySelector('[data-room1108]')) {
      cartSerial(cartNormalize).then(function (state) {
        if (state.changed && document.getElementById('pay-form')) window.location.reload();
      }).catch(function () { cartSay(cartLabels().error || ''); });
    }

    document.addEventListener('submit', function (event) {
      if (!event.target.matches('form[data-digital-checkout]')) return;
      if (!cartData() || !window.fetch) return;
      event.preventDefault();
      cartSerial(cartNormalize).then(function (state) {
        if (state.roomChanged || !roomPriceConfirmed(state.cart)) {
          cartSay(cartLabels().room_error || cartLabels().error || '');
          if (state.roomChanged) window.location.assign(cartData().cart_url);
          return;
        }
        window.location.assign(cartData().checkout_url || '/checkout');
      }).catch(function () { cartSay(cartLabels().error || ''); });
    });
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (!form.matches('form[action*="/cart/add"], form[data-cart-add]')) return;

      var data = cartData();
      if (!data || !window.fetch) return; /* no panel on the page: post as usual */

      var items = cartItems(form);
      if (!items || !items.length) return;

      event.preventDefault();

      if (form.umbralAdding) return;
      if (form.hasAttribute('data-random-add') && !form.reportValidity()) return;
      var toCheckout = form.umbralCheckout === true;
      form.umbralCheckout = false;

      var button = form.querySelector('[type="submit"]');
      var note = form.querySelector('[data-cart-note]');
      var labels = data.labels || {};

      function tell(text) {
        if (note) note.textContent = text || '';
      }

      /* The local preview has no cart behind it: show the panel as it will
         look and say so. */
      if (data.preview) {
        tell(labels.preview || '');
        cartOpen(button);
        return;
      }

      if (button && button.disabled) return;
      form.umbralAdding = true;
      if (button) button.disabled = true;
      tell(labels.adding || '');

      cartAddOnce(items)
        .then(function () {
          form.umbralAdding = false;
          if (button) button.disabled = false;
          if (form.hasAttribute('data-random-add') && window.UmbralRandomEvent) window.UmbralRandomEvent('random_added_to_cart', {source: form.getAttribute('data-random-add'), quantity: items[0].quantity});
          tell('');
          if (toCheckout) {
            window.location.assign(data.checkout_url || '/checkout');
            return;
          }
          if (data.open_on_add !== false) cartOpen(button);
        })
        .catch(function () {
          form.umbralAdding = false;
          if (button) button.disabled = false;
          tell(labels.error || '');
        });
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var opener = target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        cartOpen(opener);
        return;
      }

      if (target.closest('[data-cart-close]')) {
        event.preventDefault();
        cartClose();
        return;
      }

      var removePack = target.closest('[data-room-remove]');
      if (removePack) {
        event.preventDefault();
        if (removePack.disabled) return;
        removePack.disabled = true;
        cartSay(cartLabels().updating || '');
        cartSerial(function () { return roomRemove(removePack.getAttribute('data-room-remove')); })
          .then(function () { cartSay(''); if (document.getElementById('pay-form')) window.location.reload(); })
          .catch(function () { removePack.disabled = false; cartSay(cartLabels().error || ''); });
        return;
      }

      var change = target.closest('[data-cart-change], [data-random-change]');
      if (!change) return;

      var data = cartData();
      if (!data || !window.fetch) return; /* Remove is a real link: let it go */
      if (data.preview) {
        event.preventDefault();
        return;
      }

      var line = change.getAttribute('data-line-key');
      var quantity = Number(change.getAttribute('data-quantity'));
      var randomChange = change.hasAttribute('data-random-change');
      if (!line || !Number.isSafeInteger(quantity) || quantity < 0 || (!randomChange && quantity !== 0)) { event.preventDefault(); return; }
      if (change.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      change.setAttribute('aria-disabled', 'true');

      event.preventDefault();
      cartSay((data.labels || {}).updating || '');

      cartSerial(function () { return cartRequest(data.change_url, { id: line, quantity: quantity }); })
        .then(function () {
          cartSay('');
          if (document.getElementById('pay-form')) window.location.reload();
        })
        .catch(function () { change.removeAttribute('aria-disabled'); cartSay(cartLabels().error || ''); });
    });

    /* Escape closes; Tab stays inside the panel while it is open. */
    document.addEventListener('keydown', function (event) {
      if (!document.documentElement.classList.contains('cart-open')) return;

      if (event.key === 'Escape' || event.keyCode === 27) {
        cartClose();
        return;
      }
      if (event.key !== 'Tab' && event.keyCode !== 9) return;

      var panel = cartPanel();
      if (!panel) return;
      var list = Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]'),
        function (el) { return el.tabIndex > -1; }
      );
      if (!list.length) return;

      var first = list[0];
      var last = list[list.length - 1];
      var inside = panel.contains(document.activeElement);

      if (event.shiftKey && (!inside || document.activeElement === first)) {
        last.focus();
        event.preventDefault();
      } else if (!event.shiftKey && (!inside || document.activeElement === last)) {
        first.focus();
        event.preventDefault();
      }
    });
  }

  /* ------------------------------------------------------------------------
     4. Tiers
     The product form is a plain Shopify form: with JavaScript off it adds
     this pack alone. With it, the picked tier decides what the form sends,
     and the cart above puts all of it in one request. Tier prices are
     strings from the section settings; the totals are enforced by automatic
     discounts in the admin, never here.
     ------------------------------------------------------------------------ */

  function initTiers() {
    var form = $('bundle-form');
    var data = readJSON('umbral-bundle-data');
    if (!form || !data) return;

    var radios = form.querySelectorAll('input[name="tier"]');
    var picks = form.querySelectorAll('.tier__picks');
    var priceEl = $('bundle-price');

    function tier() {
      for (var i = 0; i < radios.length; i += 1) {
        if (radios[i].checked) return Number(radios[i].value) || 1;
      }
      return 1;
    }

    function selects(t) {
      var box = form.querySelector('.tier__picks[data-tier="' + t + '"]');
      return box ? box.querySelectorAll('select') : [];
    }

    /* Two selects in one tier must not name the same pack. */
    function dedupe(t) {
      var list = selects(t);
      if (list.length < 2) return;
      var a = list[0];
      var b = list[1];
      if (a.value !== b.value) return;
      for (var i = 0; i < b.options.length; i += 1) {
        if (b.options[i].value !== a.value) {
          b.selectedIndex = i;
          return;
        }
      }
    }

    function refresh() {
      var t = tier();
      Array.prototype.forEach.call(picks, function (box) {
        box.hidden = Number(box.getAttribute('data-tier')) !== t;
      });
      if (priceEl && data.tiers && data.tiers[t]) priceEl.textContent = data.tiers[t];
      dedupe(t);
    }

    function items(t) {
      var list = [{ id: data.current.id, quantity: 1 }];
      Array.prototype.forEach.call(selects(t), function (select) {
        var id = Number(select.value);
        if (id) list.push({ id: id, quantity: 1 });
      });
      return list;
    }

    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', refresh);
    });
    Array.prototype.forEach.call(form.querySelectorAll('.tier__picks select'), function (select) {
      select.addEventListener('change', function () { dedupe(tier()); });
    });

    /* What the add button sends: this pack, or this pack and the picks. */
    form.umbralItems = function () {
      return items(tier());
    };

    refresh();
  }

  /* ------------------------------------------------------------------------
     5. Buy now
     Any button with data-buy-now inside a product form: mark the form for
     the checkout and submit it. The cart adds the items and then goes
     straight there; with no cart on the page, return_to does the same thing
     the old-fashioned way. Without JavaScript the button is not rendered.
     ------------------------------------------------------------------------ */

  function initBuyNow() {
    var buttons = document.querySelectorAll('[data-buy-now]');
    Array.prototype.forEach.call(buttons, function (button) {
      var form = button.form || button.closest('form');
      if (!form) return;
      button.hidden = false;
      button.addEventListener('click', function () {
        var to = form.querySelector('input[name="return_to"]');
        if (!to) {
          to = document.createElement('input');
          to.type = 'hidden';
          to.name = 'return_to';
          form.appendChild(to);
        }
        to.value = button.getAttribute('data-buy-now') || '/checkout';
        form.umbralCheckout = true;
        submitForm(form);
      });
    });
  }

  /* ------------------------------------------------------------------------
     6. Language suggestion bar
     Detect, but never switch. The bar offers the visitor's browser language;
     submitting posts to Shopify's /localization endpoint, which sets the real
     locale and the /es URL prefix. Dismissal is remembered locally.
     ------------------------------------------------------------------------ */

  function initLangbar() {
    var bar = $('langbar');
    if (!bar) return;

    var close = $('langbar-close');

    function dismissed() {
      try {
        return localStorage.getItem(DISMISS_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    function dismiss() {
      try {
        localStorage.setItem(DISMISS_KEY, '1');
      } catch (e) { /* private mode, ignore */ }
    }

    if (dismissed()) return;

    var browser = primary(navigator.language);
    if (browser === primary(pageLang())) return;

    var forms = bar.querySelectorAll('.langbar__form');
    var match = null;

    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('input[name="locale_code"]');
      var offers = input && primary(input.value) === browser;
      form.hidden = !offers;
      if (offers) match = form;
    });

    if (!match) return;

    /* Taking the offer is also a decision: don't ask again. */
    match.addEventListener('submit', dismiss);
    if (close) {
      close.addEventListener('click', function () {
        dismiss();
        bar.hidden = true;
      });
    }

    bar.hidden = false;
  }

  /* Preview only: forms that point nowhere must not reload the page. */
  function initPreviewForms() {
    var forms = document.querySelectorAll('form[data-preview]');
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var note = form.querySelector('[data-preview-note]');
        if (note) note.textContent = form.getAttribute('data-preview');
      });
    });
  }

  initClock();
  initMosaic();
  initCart();
  initTiers();
  initBuyNow();
  initLangbar();
  initPreviewForms();
})();
